/* ==========================================================================
   Satjeevan — Article Content reading progress bar (sj-article-content.js)

   Fills data-sj-ac-progress-bar's width from 0-100% as the reader scrolls
   through the page. Fixed-position bar (no layout shift), rAF-throttled
   scroll listener (no unnecessary work), smoothed by the bar's own CSS
   transition rather than JS-driven easing.

   This theme keeps html/body at overflow: hidden and does its actual
   scrolling inside .page-wrapper — window.scrollY stays 0 here, so this
   reads/listens on that element instead (falling back to window/document
   if .page-wrapper isn't present, e.g. a future theme change).
   ========================================================================== */

(function () {
  'use strict';

  var bar = document.querySelector('[data-sj-ac-progress-bar]');
  if (!bar) return;

  var scroller = document.querySelector('.page-wrapper');
  var target = scroller || window;

  var ticking = false;

  function update() {
    ticking = false;
    var scrollTop, scrollable;
    if (scroller) {
      scrollTop = scroller.scrollTop;
      scrollable = scroller.scrollHeight - scroller.clientHeight;
    } else {
      var doc = document.documentElement;
      scrollTop = window.scrollY;
      scrollable = doc.scrollHeight - doc.clientHeight;
    }
    var pct = scrollable > 0 ? (scrollTop / scrollable) * 100 : 0;
    pct = Math.min(100, Math.max(0, pct));
    bar.style.width = pct + '%';
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  target.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
